<template lang="pug">
  el-dropdown(
    trigger='click',
    @visible-change="actionOnDropdownChange"
  )
    .el-dropdown-link
      el-tooltip#tooltip(
        effect='dark',
        content='Notificações',
        placement="bottom",
      )
        .notificacao
          el-badge(
            :value='novasNotificacoes',
            :max="10"
          )
            .fa-stack.fa-lg
              font-awesome-icon(icon="bell", size="2x")
    el-dropdown-menu.drop-down-menu(
      slot='dropdown'
    )
      el-dropdown-item.drop-down-item(
        v-for='(notificacao, index) in notificacoes',
        :key='notificacao.id',
      )
        .notificacao-body(
          @click="marcarLida(notificacao)"
          :class="[notificacao.recebedor.notificacaoLida ? 'visualizadas' : 'novas']"
        )
          .header
            .titulo {{ notificacao.titulo }}
            .data {{ notificacao.dataCriacao }}
          p.body {{ notificacao.mensagem }}
      .notificacao-footer
        .load-button(v-if='showLoadButton')
          a(
            @click='loadMoreNotificacoes',
            v-if='!isLoading'
          ) carregar mais
          i.el-icon-loading(v-else)
        .end-notificacao(v-else)
          span(v-if="notificacoes.length > 0") Não há mais notificações
          span(v-else) Não há notificações
      filtro(
        ref="filtroComponente"
        v-if="numeroProcesso"
        @pesquisar="pesquisaGeral",
        @limpar="clear",
        :configuracaoFiltro="configuracaoFiltro",
        :showPesquisaAvancada="false",
        :showLimpar="false",
        :pesquisaGeral="true"
        placeholder="",
        :limparCampo="false",
        :exibirFiltro="false"
      )
</template>

<script>
import { mapActions } from 'vuex'
import { intervalTime } from '../config'
import Filtro from '@/components/Filtro'
import FILTRO_EMPTY from '@/models/filtro'
const BaseFiltro = require('@/screens/analise/listagem/' + process.env.ESTADO + '/BaseFiltro').default

export default {
  components: {
    Filtro
  },

  props: {
    usuario: {
      required: true
    }
  },

  mixins: [
    BaseFiltro
  ],

  data () {
    return {
      isLoading: false,
      notificationTime: intervalTime,
      notificacoes: [],
      novasNotificacoes: 0,
      pagina: 0,
      showLoadButton: true,
      idDestinatario: this.usuario.pessoa.id,
      lida: [],
      isAp: process.env.ESTADO === 'ap',
      filtro: FILTRO_EMPTY('PESQUISA_GERAL'),
      numeroProcesso: '',
      configuracaoFiltro: {}

    }
  },

  async created () {
    this.NaoLida()
  },

  mounted () {
    this.interval = setInterval(() => {
      this.NaoLida()
    }, this.notificationTime)
  },

  beforeDestroy () {
    clearInterval(this.interval)
  },

  methods: {
    ...mapActions({
      findNotificacoes: 'notificacao/findNotificacoes',
      quantidadeNaoLidas: 'notificacao/quantidadeNaoLidas',
      marcarComoLida: 'notificacao/marcarComoLida',
      marcarArrayComoLida: 'notificacao/marcarArrayComoLida',
      atualizarNumeroProcessoPesquisaGeral: 'filtroPesquisaGeral/atualizarNumeroProcessoPesquisaGeral'
    }),

    async NaoLida () {
      this.novasNotificacoes = await this.quantidadeNaoLidas()
    },

    loadMoreNotificacoes () {
      this.pagina++
      this.getNotificacoes()
    },

    async marcarLida (notificacao) {
      if (this.isAp) {
        this.numeroProcesso = this.extractNumeroProcesso(notificacao.mensagem)

        // Aguarda o próximo ciclo de renderização
        await this.$nextTick()

        const processo = this.$refs.filtroComponente.$emit('pesquisar', {...this.filtro, campoSimples: this.numeroProcesso})
        if (['Foi enviada pelo', 'solicitação de informação'].every(item => notificacao.mensagem.includes(item))) {
          this.atualizarNumeroProcessoPesquisaGeral(this.numeroProcesso)
          if (this.$route.name !== 'INFORMACAO_SOLICITADA') {
            this.$router.push({
              name: 'INFORMACAO_SOLICITADA',
              params: {
                numeroProcesso: this.numeroProcesso
              }
            })
          }
          await this.marcarComoLida({id: notificacao.id, idUsuario: this.usuario.id})
          this.NaoLida()
          return
        }

        if (processo && processo.caixa) {
          if (this.$route.name !== processo.caixa) {
            this.atualizarNumeroProcessoPesquisaGeral(this.numeroProcesso)
            this.$router.push({ name: processo.caixa })
          }
          this.atualizarNumeroProcessoPesquisaGeral(this.numeroProcesso)
        }
        await this.marcarComoLida({id: notificacao.id, idUsuario: this.usuario.id})
        this.NaoLida()
      } else {
        await this.marcarComoLida({id: notificacao.id, idUsuario: this.usuario.id})
        this.NaoLida()
      }
    },

    async marcarTodasLidas () {
      const recebedorIds = this.notificacoes
        .filter(notificacao => !notificacao.recebedor.notificacaoLida)
        .map(notificacao => notificacao.id)

      if (recebedorIds.length > 0) {
        this.marcarArrayComoLida(recebedorIds)
      }
    },

    async getNotificacoes () {
      this.isLoading = true

      let data = await this.findNotificacoes({ simplificado: false, pagina: this.pagina })
      data.map(mensagem => {
        this.notificacoes.push(mensagem)
      })

      this.checkIfHasMorePages(data)
      this.updateLoadingAndCounter()
      this.marcarTodasLidas()
    },

    checkIfHasMorePages (data) {
      if (data.length < 10) {
        this.showLoadButton = false
      }
    },

    updateLoadingAndCounter () {
      this.isLoading = false
    },

    actionOnDropdownChange (isOpen) {
      if (isOpen) {
        this.getNotificacoes()
        return
      }
      this.onDropdownClose()
    },

    onDropdownClose () {
      this.notificacoes = []
      this.pagina = 0
      this.NaoLida()
    },
    extractNumeroProcesso (mensagem) {
    // Expressão regular para encontrar o número do processo no formato "XXXXXXXXX/YYYY"
      const regex = /\b\d{9}\/\d{4}\b/
      const match = mensagem.match(regex)

      // Retorna o número do processo encontrado ou null se não houver correspondência
      return match ? match[0] : null
    }
  }

}

</script>

<style lang="scss">
.notificacao {
  color: #a7b2bb;
  cursor: pointer;
  padding: 10px;
}

.notificacao:hover {
  color: #009f61;
}

.drop-down-menu {
  padding-top: 0px;
  max-height: 330px;
  width: 400px;
  overflow-y: auto;
  overflow-x: hidden;
}

.drop-down-item {
  cursor: default;
  padding: 0px;

  .visualizadas {
    padding: 0 10px 10px;
    border-bottom: solid 0.5px #ccc;
    background: rgba(0, 0, 0, 0.04);
  }

  .novas {
    padding: 0 10px 10px;
    border-bottom: solid 0.5px #ccc;

    .titulo {
      color: #009c66;
    }
  }
}

.notificacao-footer {
  font-size: 13px;
  display: flex;
  text-align: center;
  padding-top: 10px;

  .load-button {
    width: 100%;
  }

  a {
    cursor: pointer;
  }

  a:hover {
    color: #009f61;
  }

  .end-notificacao {
    width: 100%;
  }
}

.el-badge__content.is-fixed {
  top: 5px;
  right: 25px;
  background-color: #009c66;
}

.notificacao-body {
  .header {
    display: flex;
    flex-direction: row;
    justify-content: space-between;

    .titulo {
      font-weight: bold;
    }

    .titulo:hover {
      color: #009f61;
    }
  }

  .body {
    margin: 0;
    line-height: 1.2;
  }
}

.notificacao-body.novas:hover {
  p:first-child {
    color: #009f61;
  }
}

ul.el-dropdown-menu.el-popper::-webkit-scrollbar-track {
  background-color: #e8ebef;
}

ul.el-dropdown-menu.el-popper::-webkit-scrollbar {
  width: 4px;
}

ul.el-dropdown-menu.el-popper::-webkit-scrollbar-thumb {
  background-color: #33b281;
}

@media (max-width: 780px) {
  .drop-down-item .visualizadas {
    width: 350px;
  }
}
</style>



// WEBPACK FOOTER //
// src/screens/analise/components/AppNotificacao.vue